import {StyleSheet, css} from 'aphrodite-jss'

export const styles = StyleSheet.create({
    header_container : {
        display: "flex",
        flexDirection: "column",
        height: "163px",  
    },

    logo: {
        alignSelf: "center",
        marginTop: "8px",
        height: "70px",
        marginLeft: "450px"
    },

    light_blue: {
        display: "flex",
        flexDirection: "row",
        height: "114px",
        backgroundColor: "#00539F"
    },

    yellow: {
        height: "4px",
        backgroundColor: "#FFD300"
    },

    dark_blue: {
        height: "50px",
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#003C71"
    },

    title: {
        marginLeft: "30px",
        color: "white",
        fontSize: "18px",
        alignSelf: "center",
        fontFamily: "greycliff-bold",
        textTransform: "uppercase",
        letterSpacing: "1px",
        "-webkit-font-smoothing": "auto",
        "-moz-osx-font-smoothing": "auto",
        "& > a , & > a:hover, & > a:visited": {
            color: "white",
            textDecoration: "none"
        }
    },

    menu: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "100px",
        height: "50px"
    },

    menu_item:{
        color: "white",
        fontSize: "18px",
        paddingLeft: "20px",
        paddingRight: "20px",
        alignSelf: "center",
        fontFamily: "greycliff-bold",
        textTransform: "uppercase",
        textAlign: "center",
        letterSpacing: "1px",
        "-webkit-font-smoothing": "auto",
        "-moz-osx-font-smoothing": "auto",
        height: "48px",
        lineHeight: "48px",
        "&:hover": {
            backgroundColor: "#00284c",
            cursor: "pointer",
            textDecoration: "none",
            color: "white"
        },
        ":active":{
            color: "white",
            textDecoration: "none"
        },
        "& > a": {
            color: "white"
        },
        "& > a:visited": {
            color: "white",
            textDecoration: "none"
        }
    },

    sub_menu_item:{
        color: "white",
        backgroundColor: "#003C71",
        fontSize: "18px",
        paddingLeft: "20px",
        paddingRight: "20px",
        alignSelf: "center",
        fontFamily: "greycliff-bold",
        textTransform: "uppercase",
        textAlign: "left",
        letterSpacing: "1px",
        "-webkit-font-smoothing": "auto",
        "-moz-osx-font-smoothing": "auto",
        height: "48px",
        lineHeight: "48px",
        "&:hover": {
            backgroundColor: "#00284c",
            cursor: "pointer"
        },
        ":active":{
            textDecoration: "none"
        }
    },


    dropdown: {
        position: "relative",
        display: "inline-block",
    },

    dropdown_content: {
        display: "block",
        position: "absolute",
        backgroundColor: "#f1f1f1",
        "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)",
        "z-index": "1"
    },
    sub_dropdown_content: {
      display: "block",
      position: "absolute",
      backgroundColor: "#01f1f1",
      "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)",
      "z-index": "1"
        },

    user_account_dropdown_content: {
        display: "block",
        position: "absolute",
        left: "-85px",
        backgroundColor: "#f1f1f1",
        "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)",
        "z-index": "1"
    },

    searchBoxContainer: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#003C71",
        padding: "10px",
        width: "200px",
    },

    searchBox: {
        borderRadius: "0px",
        height: "35px",
        width: "350px",
        padding: "5px"
    },

    searchAdvancedOptions: {
        marginTop: "5px",
        marginLeft: "auto",
        color: "white",
        "&:hover":{
            color: "white",
            cursor: "pointer",
            textDecoration: "underline"
        }
    },

    searchOptionsContainer: {
        display: "flex",
        flexDirection: "column",
        alignitems: "left",
        marginTop: "10px",
        marginBottom: "10px",
        marginLeft: 'auto'
    },

    searchOption: {
        "& > input": {
            marginRight: "10px"
        },
        "& > label": {
            color: "white",
            fontSize: '16px'
        },
        marginRight: "15px"
    }



   
});


// WEBPACK FOOTER //
// ./src/styles/Navbar.ts